import { PlusOutlined } from "@ant-design/icons";
import { Button, Divider, Input, Select, Space, message } from "antd";
import React, { useEffect, useRef, useState } from "react";
import { getQuizTheme } from "../../requests";
import { createTheme, getThemeByThemeId } from "../../requests/theme";

function ThemeSelector(props){

    const {themeDisabled, showAddItem, options, theme} = props;
    const [items, setItems] = useState(options);
    const [name, setName] = useState(null);
    const [messageApi, contextHolder] = message.useMessage();

    const inputRef = useRef(null);
    const user = JSON.parse(localStorage.getItem('user'));
    const si = (items).map((item) => ({
        label: item.theme_name,
        value: item.theme_id,
    }));
    const hasOptions = !!options;

    useEffect(()=>{
        const func = async ()=>{
            if(!hasOptions){
                const themeItems = await getQuizTheme(user.user_id);
                setItems(themeItems.themeList)
            }
        }
        try{
            func();
        }catch(err){
            console.log(err);
        }
    }, [])

    const addItem = async (e) => {
        e.preventDefault();
        if(items.map(ele=>ele.theme_name).indexOf(name) !== -1){
            messageApi.warning('You already have this theme');
            return;
        }
        
        const {theme_id} = await createTheme({user_id: user.user_id, theme_name: name});
        const t = await getThemeByThemeId(theme_id);
        setItems([...items, t]);
        setName('');
        setTimeout(() => {
            inputRef.current?.focus();
        }, 0);
    };

    const onNameChange = (event) => {
        setName(event.target.value);
    };



    return (
        <>
            {contextHolder}
            <span className="fs-5 fw-bold">Theme</span>
            <Select
                style={{
                    width: '100%',
                    zIndex: 10000
                }}
                allowClear
                className="my-ant-input"
                placeholder="Select theme"
                options={si}
                disabled={themeDisabled}
                value={theme}
                onChange={props.onThemeChange}
                dropdownRender={(menu) => (
                    <>
                        {menu}
                        {showAddItem ? <><Divider
                            style={{
                            margin: '8px 0',
                            }}
                        />
                        <Space
                            style={{
                            padding: '0 8px 4px',
                            }}
                        >
                            <Input
                                placeholder="Please enter item"
                                ref={inputRef}
                                value={name}
                                onChange={onNameChange}
                                onKeyDown={(e) => e.stopPropagation()}
                                maxLength={30} 
                            />
                            <Button type="text" icon={<PlusOutlined />} onClick={addItem}>
                                Add item
                            </Button>
                        </Space></> : null}
                    </>
                )}
            />
        </>
    );
}


export default ThemeSelector;